// =============================================================================
// src/lib/versionCheckCore.js - is a newer build of the app deployed?
// A tab opened before a deploy keeps running the old code until it reloads
// (Oct 2026: a desktop tab left open all day still had chart notes that did
// not open, while the phone, freshly loaded, had the fix). Each build names
// its entry bundle /assets/index-<hash>.js; a different name in the served
// index.html means a newer build is live. Pure: node:test loads it.
// =============================================================================
const ENTRY = /\/assets\/index-[A-Za-z0-9_-]+\.js/;

// The entry bundle named in an index.html text, or null.
export function entryFromHtml(html) {
  const m = String(html || "").match(ENTRY);
  return m ? m[0] : null;
}

// The entry bundle this tab is running (from its script tags' src values).
export function entryFromScripts(srcs) {
  for (const s of srcs || []) {
    const m = String(s || "").match(ENTRY);
    if (m) return m[0];
  }
  return null;
}

// A newer build is live: both names known and different. Unknown (dev
// server, failed fetch, unexpected page) is never "newer".
export function isNewerBuild(running, served) {
  return !!(running && served && running !== served);
}
